<template>
    <edit-view-base :filter="filter" :has-card-view="true" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Queen Purchase', apiMethod: 'QueenPurchases', form: () => import('../forms/QueenPurchaseForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Queen Introduction', apiMethod: 'QueenIntroductions', parentForeignKey: 'queenPurchaseId', form: () => import('../forms/QueenIntroductionForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Queen Introductions', value: 'queenPurchaseId', isCard: true, table: () => import('../tables/QueenIntroductionsTable') },
                ],
                mainForm: () => import('../forms/QueenPurchaseForm'),
                claimName: 'QueenPurchases',
                apiMethod: 'QueenPurchases',
            }
        }
    };
</script>
